var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loading-indicator', { 'full-screen': _vm.fullScreen }]},[_c('img',{staticClass:"loading-image",attrs:{"src":require("@/assets/img/loading.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }